/* eslint-disable max-len */
// Utility
export const ANALYTICS_EVENT_UTILITY_PARTNER_SIGNUP = 'Utility Partner Signup';
export const ANALYTICS_EVENT_UTILITY_PARTNER_USER_SIGNUP = 'Utility Partner User Signup';
export const ANALYTICS_EVENT_UTILITY_PARTNER_STATUS_UPDATED = 'Utility Partner Status Updated';
export const ANALYTICS_EVENT_UTILITY_PARTNER_ADDED_PARTNER_USER =
  'Utility Partner Added Partner User';
export const ANALYTICS_EVENT_UTILITY_PARTNER_ACTIVATED = 'Utility Partner Activated';
export const ANALYTICS_EVENT_UTILITY_PARTNER_SELF_ONBOARDING_STEP_COMPLETED =
  'Utility Partner Self Onboarding Step Completed'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_UTILITY_PARTNER_TRANSFER_MONEY_INITIATED =
  'Utility Profit Transfer Money Initiated';
export const ANALYTICS_EVENT_UTILITY_ACTIVATION_ARCHIVED_CHANGED_ADDRESS =
  'Utility Activation Archived - Changed Address';
export const ANALYTICS_EVENT_UTILITY_ACTIVATION_ARCHIVED_DELETED_ACTIVATION =
  'Utility Activation Archived - Deleted Activation';
export const ANALYTICS_EVENT_UTILITY_ACTIVATION_FEEDBACK_SUBMITTED =
  'Utility Activation Feedback Submitted';
export const ANALYTICS_EVENT_UTILITY_USER_SIGNUP = 'Utility User Signup';
export const ANALYTICS_EVENT_UTILITY_USER_LOGIN = 'Utility User Login';
export const ANALYTICS_EVENT_UTILITY_USER_SMS_SENT = 'Utility User SMS Sent';
export const ANALYTICS_EVENT_UTILITY_USER_COMPLETED_ALL_UTILITIES =
  'Utility User Completed All Utilities';
export const ANALYTICS_EVENT_UTILITY_USER_NO_INTERNET_REQUIRED =
  'Utility User No Internet Required';
export const ANALYTICS_EVENT_UTILITY_USER_REQUESTED_INTERNET_PURCHASE =
  'Utility User Requested Internet Purchase';
export const ANALYTICS_EVENT_UTILITY_USER_PURCHASE_INTERNET_OUTSIDE_TOOL =
  'Utility User Purchased Internet Outside Tool';
export const ANALYTICS_EVENT_UTILITY_USER_LEASE_START_DATE_HAS_HAPPENED =
  'Utility User Lease Start Date Has Happened';
export const ANALYTICS_EVENT_UTILITY_USER_AUTOTEXT_MIGRATION = 'Utility User Autotext Migration';
export const ANALYTICS_EVENT_UTILITY_USER_LEASE_START_DATE_UPDATED =
  'Utility Setup Lease Start Date Updated';
export const ANALYTICS_EVENT_UTILITY_SETUP_UTILITIES_NOT_MAPPED =
  'Utility Setup Utilities Not Mapped';
export const ANALYTICS_EVENT_UTILITY_SETUP_UTILITIES_MAPPED = 'Utility Setup Utilities Mapped';
export const ANALYTICS_EVENT_UTILITY_SETUP_STOP_REMINDERS_FOR_RENTER =
  'Utility Setup Stop Reminders for Renter';
export const ANALYTICS_EVENT_UTILITY_SETUP_BCC_FOR_RENTER = 'Utility Setup BCC for Renter';
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_PLAN_SELECTED = 'Internet Plan Selected';
export const ANALYTICS_EVENT_UTILITY_SETUP_BULK_IMPORT =
  'Utility Profit Future Tenant Synced From Property Management Software'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_UTILITY_SETUP_BULK_IMPORT_FAILED =
  'Utility Profit Failed Property Management Sync';
export const ANALYTICS_EVENT_UTILITY_PMS_SYNC_COMPLETED = 'Utility PMS Sync Completed';
export const ANALYTICS_EVENT_UTILITY_PMS_SYNC_STOPPED = 'Utility Partner PMS Sync Stopped';
export const ANALYTICS_EVENT_UTILITY_PMS_NEVER_SYNCED = 'Utility Partner PMS Never Synced';
export const ANALYTICS_EVENT_UTILITY_LEASE_START_DATE_CHANGED = 'Lease Start Date Changed';

export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_SEARCH_PROVIDER_NAME =
  'Transfer Internet: 1 Search Provider'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_PROVIDER_AVAILABLE =
  'Transfer Internet: 2a Provider Available';
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_PROVIDER_NOT_AVAILABLE =
  'Transfer Internet: 2b Provider Not Available';
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_CURRENT_PLAN_DETAILS =
  'Transfer Internet: 2c Current Plan Details';
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_NEW_CUSTOMER_DEALS =
  'Transfer Internet: 3 Available Provider Plans';
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_CONTACT_PROVIDER =
  'Transfer Internet: 3 Available Contact Provider';
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_CONFIRM_ORDER =
  'Transfer Internet: 4 Available Provider Confirm Order';
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_MATCHING_PLAN =
  'Transfer Internet: 4 See Matching Plan'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_RETURN_EQUIPMENT =
  'Transfer Internet: 5 Return Equipment'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_TRANSFER_CURRENT_PLAN =
  'Transfer Internet: Opt Out Options'; // eslint-disable-line max-len
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_TRANSFER_REASON =
  'Transfer Internet: Opt Out Note for Landlord';
export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_BACK_TO_INITIAL_STATE =
  'Transfer Internet: Back to Initial State'; // eslint-disable-line max-len

// Stripe payouts for utility partners
export const ANALYTICS_EVENT_UTILITY_PARTNER_PAYOUT_PAID = 'Utility Partner Payout Paid';
export const ANALYTICS_EVENT_UTILITY_PARTNER_PAYOUT_FAILED = 'Utility Partner Payout Failed';

export const ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_LIST = [
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_SEARCH_PROVIDER_NAME,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_PROVIDER_AVAILABLE,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_PROVIDER_NOT_AVAILABLE,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_CURRENT_PLAN_DETAILS,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_NEW_CUSTOMER_DEALS,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_CONTACT_PROVIDER,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_CONFIRM_ORDER,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_MATCHING_PLAN,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_RETURN_EQUIPMENT,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_TRANSFER_CURRENT_PLAN,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_TRANSFER_REASON,
  ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_BACK_TO_INITIAL_STATE,
];

// DEPRECATED
/* eslint-disable no-unused-vars */
const ANALYTICS_EVENT_TOUR_REQUEST_EMAIL_SENT = 'Tour Request Email Sent';
const ANALYTICS_EVENT_SCHEDULE_TOUR = 'Schedule Tour';
const ANALYTICS_EVENT_SCHEDULE_FIRST_TOUR = 'Schedule First Tour';
const ANALYTICS_EVENT_PAGE_LOAD = 'Page Load';
const ANALYTICS_EVENT_MAP_SEARCH_MARKER_CLICK = 'Map Search Clicked Pin';
const ANALYTICS_EVENT_FEED_CATEGORY_LISTING_CLICK = 'Feed Category Listing Click';
const ANALYTICS_EVENT_SIGNUP = 'Signup';
const ANALYTICS_EVENT_LOGIN = 'Login';
const ANALYTICS_EVENT_LOGOUT = 'Logout';
const ANALYTICS_EVENT_USER_ADDRESS_SEARCH = 'User Address Search';
const ANALYTICS_EVENT_BOOKMARK_ADD = 'Bookmark Add';
const ANALYTICS_EVENT_RENTER_APPLICATION_FIELD_UPDATE = 'Renter Application Field Updated';
const ANALYTICS_EVENT_RENTER_APPLICATION_FORM_SUBMIT = 'Renter Application Form Submitted';
const ANALYTICS_EVENT_APPLICATION_PAID = 'Application Paid';
const ANALYTICS_EVENT_SEARCH_FILTERS_UPDATE = 'Search Filters Update';

const ANALYTICS_EVENT_PAGE_VIEWED = 'Page Viewed';
const ANALYTICS_EVENT_USER_SESSION = 'User Session';
const ANALYTICS_EVENT_LOGO_CLICK = 'Logo Click';
const ANALYTICS_EVENT_ROOMMATE_SIGNUP = 'Roommate Signup';
const ANALYTICS_EVENT_GUARANTOR_SIGNUP = 'Guarantor Signup';
const ANALYTICS_EVENT_LEAD_FORM_COMPLETED = 'Lead Form Completed';
const ANALYTICS_EVENT_SHOWING_ADDED_TO_TOUR = 'Showing Added To Tour';
const ANALYTICS_EVENT_SHOWING_REMOVED_BY_USER = 'Showing Removed By User';
const ANALYTICS_EVENT_SHOWING_MARKED_AS_FAILED_BY_CS = 'Showing Marked As Failed By CS';
const ANALYTICS_EVENT_SHOWING_MARKED_AS_FAILED_BY_ONFLEET = 'Showing Marked As Failed By Onfleet'; // eslint-disable-line max-len
const ANALYTICS_EVENT_TEXT_AGENT_BUTTON_CLICK = 'Button Click: Text Agent';
const ANALYTICS_EVENT_SEARCH_FILTERS_UPDATED = 'Search Filters Updated';
const ANALYTICS_EVENT_SUGGESTED_SEARCH_FILTERS_CLICK = 'Suggested Search Filters Click';
const ANALYTICS_EVENT_LISTING_PHOTO_CLICK = 'Listing Photo Click';
const ANALYTICS_EVENT_LISTING_BOOKMARKED = 'Listing Bookmarked';
const ANALYTICS_EVENT_LISTING_REMOVED_FROM_BOOKMARK = 'Listing Removed From Bookmark';
const ANALYTICS_EVENT_TOUR_STATUS_UPDATE = 'Tour Status Update';
const ANALYTICS_EVENT_APPLICATION_STATUS_UPDATE = 'Application Status Update';
const ANALYTICS_EVENT_SECURITY_DEPOSIT_PAID = 'Security Deposit Paid';
const ANALYTICS_EVENT_SECURITY_DEPOSIT_PAYMENT_INITIATED = 'Security Deposit Payment Initiated';
const ANALYTICS_EVENT_SECURITY_DEPOSIT_PAYMENT_FAILED = 'Security Deposit Payment Failed';
const ANALYTICS_EVENT_CALL_BUTTON = 'Call Button in Listing Page';
const ANALYTICS_EVENT_USER_PHONE_CONFIRMED = 'User Phone Confirmed';
const ANALYTICS_EVENT_HOUSEHOLD_USER_REMOVED = 'Household User Removed';
const ANALYTICS_EVENT_CLICKED_NON_MATCHED_HOMES = 'Non-matched Homes List Expanded';
const ANALYTICS_EVENT_SMS_LISTING_PREQUAL_CONFIRM = 'User Confirms Listing Prequalifications';
const ANALYTICS_EVENT_MAP_SEARCHED = 'Map Searched';
const ANALYTICS_EVENT_ADDRESS_SEARCHED = 'Address Searched';
const ANALYTICS_EVENT_USER_SETTINGS_UPDATE = 'User Settings Update';
const ANALYTICS_EVENT_STREET_VIEW_CLICK = 'Street View Click';
const ANALYTICS_EVENT_APARTMENT_LOCATOR_CONTACT_BUTTON_CLICK =
  'Apartment Locator Contact Button Click'; // eslint-disable-line max-len
const ANALYTICS_EVENT_APARTMENT_LOCATOR_CHECK_AVAILABILITY_BUTTON_CLICK =
  'Apartment Locator Check Availability Button Click'; // eslint-disable-line max-len
const ANALYTICS_EVENT_GUARANTOR_APPLICATION_FORM_SUBMIT = 'Guarantor Application Form Submitted';
const ANALYTICS_EVENT_SUNROOM_CLUB_PAID = 'Sunroom Select Paid';
const ANALYTICS_EVENT_SUNROOM_CLUB_FORM_SUBMITTED = 'Sunroom Select Form Submitted';
const ANALYTICS_EVENT_SUNROOM_CLUB_TOAST_CTA_CLICK = 'Sunroom Select Toast CTA Click';
const ANALYTICS_EVENT_TOUR_RESCHEDULE_BUTTON_CLICK = 'Tour Reschedule CTA Click';
const ANALYTICS_EVENT_TOUR_RESCHEDULE_LINK_CLICK = 'Tour Reschedule Blue Link Click';
const ANALYTICS_EVENT_PREQUAL_COMPLETED = 'Prequal Completed';
const ANALYTICS_EVENT_PREQUAL_COMPLETED_REQUEST_TOUR_PROMPT_NO_IMAGE =
  'Prequal Completed Request Tour Page Prompt No Image'; // eslint-disable-line max-len
const ANALYTICS_EVENT_PREQUAL_COMPLETED_REQUEST_TOUR_PROMPT_WITH_LISTING_IMAGE =
  'Prequal Completed Request Tour Page Prompt With Listing Image'; // eslint-disable-line max-len
const ANALYTICS_EVENT_PREQUAL_COMPLETED_REQUEST_TOUR_PROMPT_OPT_OUT =
  'Prequal Completed Request Tour Page Prompt Opt Out'; // eslint-disable-line max-len
const ANALYTICS_EVENT_PREQUAL_CTA_CLICK = 'Prequal CTA Click';
const ANALYTICS_EVENT_FEED_CHANGE_FILTERS_CLICK = 'Feed Change Filters Click';
const ANALYTICS_EVENT_FEED_CATEGORY_VIEW_ALL_CLICK = 'Feed Category View All Click';
const ANALYTICS_EVENT_FEED_CATEGORY_CHANGE_FILTERS_CLICK = 'Feed Category Change Filters Click';
const ANALYTICS_EVENT_FEED_CATEGORY_CHANGE_QUALIFICATIONS_CLICK =
  'Feed Category Change Qualifications Click'; // eslint-disable-line max-len
const ANALYTICS_EVENT_ONLINE_APP_REQUESTED = 'Online App Requested';
const ANALYTICS_EVENT_CUSTOMER_IO_WEBHOOK_EVENT = 'Customer.io Webhook Event';
const ANALYTICS_EVENT_SUNROOM_SMS_SENT = 'Sunroom SMS Sent';
const ANALYTICS_EVENT_RENTER_SMS_SENT = 'Renter SMS Sent';
const ANALYTICS_EVENT_EXTERNAL_AGENT_TOUR_REQUESTED = 'External Agent Tour Requested';
const ANALYTICS_EVENT_AGENT_TOUR_REQUESTED = 'Agent Tour Requested';
const ANALYTICS_EVENT_AGENT_FIRST_TOUR_REQUESTED = 'Agent First Tour Requested';
const ANALYTICS_EVENT_SHOWING_ADDED_TO_AGENT_TOUR = 'Showing Added To Agent Tour';
const ANALYTICS_EVENT_SHOWING_REMOVED_FROM_AGENT_TOUR = 'Showing Removed From Agent Tour';
const ANALYTICS_EVENT_AGENT_TOUR_CONFIRMED = 'Agent Tour Confirmed';
const ANALYTICS_EVENT_AGENT_SHOWING_COMPLETED = 'Agent Showing Completed';
const ANALYTICS_EVENT_AGENT_SHOWING_CANCELED = 'Agent Showing Canceled';
const ANALYTICS_EVENT_AGENT_SHOWING_FAILED = 'Agent Showing Failed';
const ANALYTICS_EVENT_AGENT_TOUR_CANCELED = 'Agent Tour Canceled';
const ANALYTICS_EVENT_AGENT_TOUR_COMPLETED = 'Agent Tour Completed';
const ANALYTICS_EVENT_AGENT_TOUR_FAILED = 'Agent Tour Failed';
const ANALYTICS_EVENT_LOCATOR_TOUR_STARTED = 'Locator Tour Started';
const ANALYTICS_EVENT_LOCATOR_TOUR_COMPLETED = 'Locator Tour Completed';
const ANALYTICS_EVENT_LOCATOR_SHOWING_STARTED = 'Locator Showing Started';
const ANALYTICS_EVENT_LOCATOR_SHOWING_COMPLETED = 'Locator Showing Completed';
const ANALYTICS_EVENT_SELF_TOUR_INITIATED = 'Self Tour Initiated';
const ANALYTICS_EVENT_SELF_TOUR_COMPLETED = 'Self Tour Completed';
const ANALYTICS_EVENT_GATE_ACCESS_SUPPORT_CALLED = 'Support for Gate Access Called';
const ANALYTICS_EVENT_CODEBOX_SUPPORT_CALLED = 'Support for Codebox Called';
const ANALYTICS_EVENT_DOOR_ACCESS_SUPPORT_CALLED = 'Support for Door Access Called';
const ANALYTICS_EVENT_SUPRA_TOUR_COMPLETED = 'Supra Tour Completed';
const ANALYTICS_EVENT_AGENT_TOUR_RESCHEDULED = 'Agent Tour Rescheduled';
const ANALYTICS_EVENT_AGENT_TOUR_SHOWING_CONFIRMED = 'Agent Tour Showing Confirmed';
const ANALYTICS_EVENT_CTA_CLICKED = 'CTA Clicked';
const ANALYTICS_EVENT_SIGNUP_FUNNEL_STEP_COMPLETED = 'Signup Funnel Step Completed';
const ANALYTICS_EVENT_SIGNUP_FUNNEL_COMPLETED = 'Signup Funnel Completed';
const ANALYTICS_EVENT_SIGNED_IN = 'Signed In';
const ANALYTICS_EVENT_SIGNED_OUT = 'Signed Out';
const ANALYTICS_EVENT_BLUE_DOT_MAP_CLICKED = 'Blue Dot Map Clicked';
const ANALYTICS_EVENT_ACCOUNT_CREATED = 'Account Created';
const ANALYTICS_EVENT_LISTING_CATEGORY_VIEWED = 'Listing Category Viewed';
const ANALYTICS_EVENT_LISTING_VIEWED = 'Listing Viewed';
const ANALYTICS_EVENT_LISTING_WITHDRAWN = 'Listing Withdrawn';
const ANALYTICS_EVENT_APPLICATION_STEP_COMPLETED = 'Application Step Completed';
const ANALYTICS_EVENT_PREQUAL_STEP_COMPLETED = 'Prequal Step Completed';
const ANALYTICS_EVENT_APPLICATION_COMPLETED = 'Application Completed';
const ANALYTICS_EVENT_APPLICATION_ACCEPTED = 'Application Accepted';
const ANALYTICS_EVENT_APPLICATION_REJECTED = 'Application Rejected';
const ANALYTICS_EVENT_HOUSEHOLD_APPLICATION_COMPLETED = 'Household Application Completed';
const ANALYTICS_EVENT_HOUSEHOLD_APPLICATION_ACCEPTED = 'Household Application Accepted';
const ANALYTICS_EVENT_APPLICATION_FEE_PAID = 'Application Fee Paid';
const ANALYTICS_EVENT_LEASE_SIGNED = 'Lease Signed';
const ANALYTICS_EVENT_LISTING_SHARE_CLICKED = 'Listing Share Clicked';
const ANALYTICS_EVENT_MAP_RELOADED = 'Map Reloaded';
const ANALYTICS_EVENT_CONTACT_BUTTON_CLICKED = 'Contact Button Clicked';
const ANALYTICS_EVENT_CALL_BUTTON_CLICKED = 'Call Button Clicked';
const ANALYTICS_EVENT_TEXT_BUTTON_CLICKED = 'Text Button Clicked';
const ANALYTICS_EVENT_ROOMMATE_REMOVED_FROM_HOUSEHOLD = 'Roommate Removed From Household';
const ANALYTICS_EVENT_GUARANTOR_REMOVED_FROM_HOUSEHOLD = 'Guarantor Removed From Household';
const ANALYTICS_EVENT_BUYERS_SIDE_APPLICATION_REQUESTED = 'Buyers Side Application Requested';
const ANALYTICS_EVENT_3D_TOUR_OPENED = '3D Tour Opened';
const ANALYTICS_EVENT_3D_TOUR_CLOSED = '3D Tour Closed';
const ANALYTICS_EVENT_PARTNER_CALLED = 'Partner Called';
const ANALYTICS_EVENT_BACKGROUND_CREDIT_CHECKED = 'Background and Credit Checked';
const ANALYTICS_EVENT_SUNROOM_LISTING_MADE_ACTIVE = 'Sunroom Listing Made Active';
const ANALYTICS_EVENT_START_PAGE_VISITED = 'Start Page Visited';
const ANALYTICS_EVENT_PARTNER_SOLD = 'Partner Sold';
const ANALYTICS_EVENT_EMPLOYER_VERIFICATION_SENT = 'Employer Verification Sent';
const ANALYTICS_EVENT_LANDLORD_VERIFICATION_SENT = 'Landlord Verification Sent';
const ANALYTICS_EVENT_AGENT_PARTNER_DASHBOARD_SEE_HOW_IT_WORKS_LINK_CLICKED =
  'Agent Partner Dashboard How It Works Link Clicked'; // eslint-disable-line max-len
const ANALYTICS_EVENT_MARKET_PROPERTY_SUBMITTED = 'Market Property Submitted';
const ANALYTICS_EVENT_MARKET_PROPERTY_SUBMITTED_BY_OWNER = 'Market Property Submitted By Owner';
const ANALYTICS_EVENT_PARTNER_USER_CREATED = 'Partner User Created';
const ANALYTICS_EVENT_PARTNER_LEAD_CREATED = 'Partner Lead Created';
const ANALYTICS_EVENT_PARTNER_LISTING_RENEWAL_DRIP_STARTED = 'Partner Listing Renewal Drip Started';
const ANALYTICS_EVENT_PARTNER_LISTING_RENEWAL_EMAILS_STOPPED =
  'Partner Listing Renewal Emails Stopped'; // eslint-disable-line max-len

// Sendgrid
const ANALYTICS_EVENT_EMAIL_DELIVERED = 'Email Delivered';
const ANALYTICS_EVENT_EMAIL_OPENED = 'Email Opened';
const ANALYTICS_EVENT_EMAIL_CLICKED = 'Email Clicked';
const ANALYTICS_EVENT_EMAIL_BOUNCED = 'Email Bounced';
const ANALYTICS_EVENT_EMAIL_DROPPED = 'Email Dropped';
const ANALYTICS_EVENT_EMAIL_SPAM_REPORT = 'Email Spam Report';
const ANALYTICS_EVENT_EMAIL_UNSUBSCRIBE = 'Email Unsubscribe';
const ANALYTICS_EVENT_EMAIL_GROUP_UNSUBSCRIBE = 'Email Group Unsubscribe';
const ANALYTICS_EVENT_EMAIL_GROUP_RESUBSCRIBE = 'Email Group Resubscribe';
/* eslint-enable no-unused-vars */
/* eslint-enable max-len */
